var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"custom-scrollbar user-select-none",attrs:{"id":"app"}},[_c('keep-alive',{attrs:{"include":_vm.$store.state.keepAlivePages}},[_c('router-view')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }